/**
 * created by wang lei
 插入表格页面
 *
 */
import React, {Component} from 'react';
import insertTable from './insertTable.png';
import BaseComponent from "../../../../../base/BaseComponent";
import onClickOutside from "react-onclickoutside";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

const getTableHTML = (row, col)=>{
    return `<table cellpadding="0" width="100%" cellspacing="0" border="1"><tbody>${(()=>{
        let trs = [];
        for(let i = 0; i < row; i++){
            let lastWidth = 100;
            trs.push(`<tr>${(()=>{
                let tds = [];
                for(let j = 0; j < col; j++){
                    if(j === col - 1){
                        tds.push(`<td width="${lastWidth}%" height="30"></td>`);   
                    }else{
                        let width = Math.floor(100/col);
                        lastWidth = lastWidth - width;
                        tds.push(`<td width="${width}%" height="30"></td>`);
                    }
                }
                return tds.join(" ");
            })()}</tr>`);
        }
        return trs.join(" ");
    })()}</tbody></table>`
};

export default class InsertTableTool extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }

    listenContentClick(){
        this.setState({
            show: false
        })
    }

    render() {
        return (
            <span style={{cursor:"pointer",position:"relative"}}>
                <img className={"editor-insert-table-tool-btn"} src={insertTable} onClick={()=>this.setState({show:true})}/>
                <TableFloatPanelOutside
                    hide={()=>{this.state.show = false}}
                    show={this.state.show}
                    onClick={(currentI, currentY)=>{
                        let _html = getTableHTML(currentI + 1, currentY + 1);
                        let isSuccess = this.props.editor.rmtExecCommand("inserthtml", _html);
                        if(isSuccess) {
                            this.setState({
                                show: false
                            })
                        }
                    }}
                />
                <style>{`
                .editor-insert-table-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-insert-table-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-insert-table-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        )
    }
}

class TableFloatPanel extends BaseComponent{

    static defaultProps = {
        hide:()=>{},
        row: 10,
        col: 10,
        size: 20,
        show: false,
        onClick:(currentI, currentY)=>{}
    };

    handleClickOutside = (evt) => {
        this.setState({
            show: false
        });
        this.props.hide();
    };

    constructor(props) {
        super(props);
        this.state = {
            show: props.show,
            currentI: 0,
            currentY: 0
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.state.show = nextProps.show;
    }

    mouseOver = (currentI, currentY)=>{
        this.setState({
            currentI, currentY
        })
    };

    render() {
        return <FloatPanel show={this.state.show} width={this.props.col * this.props.size} height={this.props.row * this.props.size}>
            <table cellSpacing={0} cellPadding={0} border={1}><tbody>
            {(()=>{
                let trs = [];
                for(let i = 0 ; i < this.props.row; i++){
                    trs.push(<tr key={i}>
                        {(()=>{
                            let tds = [];
                            for(let j = 0 ; j < this.props.col; j++){
                                let isChecked = false;
                                if(i <= this.state.currentI && j <= this.state.currentY ){
                                    isChecked = true;
                                }
                                tds.push(<td style={{background: isChecked?this.themeBgColor:"#fff"}} onMouseOver={()=>this.mouseOver(i, j)}
                                             onClick={()=>this.props.onClick(i, j)}
                                             key={`${i}_${j}`} width={this.props.size} height={this.props.size}><></></td>);
                            }
                            return tds;
                        })()}
                    </tr>);
                }
                return trs;
            })()}
            </tbody></table>
        </FloatPanel>
    }
}

let TableFloatPanelOutside = onClickOutside(TableFloatPanel);

class FloatPanel extends Component{

    static defaultProps = {
        width : 100,
        height : 100,
        top : 20,
        left : 20,
    };

    render() {
        return <div style={{position: "absolute", display: this.props.show?"block":"none",
            width: this.props.width, zIndex: 999, top: this.props.top, left: this.props.left,
            borderRadius: "5px", boxShadow : "rgb(0 0 0 / 50%) 5px 4px 7px 0px", background:"#fff",
            height: this.props.height}}>
            {React.Children.map(this.props.children, child => child)}
        </div>
    }
}